import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

import { Store } from "@vattenfall/core";

import { AutocompleteSearchElement } from "./autocomplete-search.element";

@NgModule({
  declarations: [AutocompleteSearchElement],
  imports: [CommonModule, ReactiveFormsModule],
  exports: [AutocompleteSearchElement],
  bootstrap: [AutocompleteSearchElement],
  providers: [Store],
})
export class AutocompleteSearchModule {}
